import {
    LISTAR_INTEGRACOES,
    // SELECIONAR_INTEGRACOES,
    LISTAR_RAMAIS,
    LISTAR_TRONCOS,
    LISTAR_TAGS,
    LISTA_SEGWARE,
    LISTAR_AUDIOS,
    LISTA_IA,
    LISTA_OPERADOR,
  } from './mutation-types'
  
  export default {
    [LISTAR_INTEGRACOES]: (state, integracoes) => {
      state.integracoes = integracoes
    },
    // [SELECIONAR_INTEGRACOES]: (state, agendamento) => {
    //   state.agendamentoSelecionado = agendamento
    // },
    [LISTAR_RAMAIS]: (state, ramais) => {
      state.ramais = ramais
    },
    [LISTAR_TRONCOS]: (state, troncos) => {
      state.troncos = troncos
    },
    [LISTAR_TAGS]: (state, tags) => {
      state.tags = tags
    },
    [LISTA_SEGWARE]: (state, segware) => {
      state.segware = segware
    },
    [LISTAR_AUDIOS]: (state, audios) => {
      state.audios = audios
    },
    [LISTA_IA]: (state, ia) => {
      state.ia = ia
    },
    [LISTA_OPERADOR]: (state, operador) => {
      state.operador = operador
    },
  }
  